// extracted by mini-css-extract-plugin
export default {"container":"AboutUs_container__b1nrU","bookNowBtnStyle":"AboutUs_bookNowBtnStyle__jSGxH","footerStyle":"AboutUs_footerStyle__UGhS+"};